import { Icon } from "PFComponents/icon";
import { LoadingDots } from "PFComponents/loading_dots";
import { Typography } from "PFComponents/typography";
import { IconName } from "PFTheme/graphics/icons";
import React from "react";

import css from "./row_menu.modules.scss";

export type RowMenuDisplayElementProps = {
  label: string;
  icon?: IconName;
  isLoading?: boolean;
};

export const RowMenuDisplayElement = ({ icon, label, isLoading }: RowMenuDisplayElementProps) => {
  if (isLoading) {
    return <LoadingDots />;
  }
  return (
    <div className={css.rowMenuItem} title={label}>
      {icon && (
        <div className={css.icon}>
          <Icon name={icon} size="xs" color="paletteBlue0" />
        </div>
      )}
      <Typography variant="bodyRegular" noMargin clipOverflow className={css.label}>
        {label}
      </Typography>
    </div>
  );
};
